export default __webpack_public_path__ + "static/media/icon-upgrade.926b2bab.svg";